<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="card">
        <p class="title">Create an Order</p>
        <div class="inputs filters">
          <div class="input">
            <label>Select Client</label>
            <v-select
              class="multiple"
              v-model="selectedClient"
              label="first_name"
              :options="clients"
            >
              <template v-slot:option="option">
                <div>{{ `${option.first_name} ${option.last_name}` }}</div>
              </template>
            </v-select>
          </div>

          <div class="input full">
            <label>Select Products</label>
            <v-select
              class="multiple"
              v-model="selectedProducts"
              multiple
              label="sku"
              :options="inventory"
            >
              <template v-slot:option="option">
                <div>{{ option.name }} - {{ option.sku }}</div>
              </template>
            </v-select>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Sku</th>
              <th>Discounted Price</th>
              <th>Discount %</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in selectedProducts">
              <tr :key="i" :class="{ grey: i % 2 }">
                <td data-label="Item">
                  <div class="img-text">
                    <img
                      class="thumb"
                      :src="require('@/assets/img/kiosk.png')"
                    />{{ item.name }}
                  </div>
                </td>
                <td data-label="Sku">{{ item.sku }}</td>
                <td data-label="Discounted Price">
                  {{ formatPrice(calcDiscountedPrice(item)) }}
                </td>
                <td data-label="Discount %">
                  {{ calculateDiscountPercentage(item) }}
                </td>
                <td data-label="Quantity">
                  <input
                    min="1"
                    @input="checkNum(item)"
                    class="unit-quantity"
                    type="number"
                    v-model.number="item.selected_quantity"
                  />
                </td>
                <!-- <td>${{ item.price }}</td>
                <td>{{ formatPrice(item.price * item.selected_quantity) }}</td> -->
              </tr>
            </template>
          </tbody>
        </table>

        <div class="totals">
          <p>
            Total
            <span>
              {{ formatPrice(calcTotalPrice) }}
            </span>
          </p>
        </div>
        <div class="btns right">
          <button @click="completeOrder" class="btn round-btn">
            Send Order
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;

export default {
  data() {
    return {
      details: null,
      user: this.$store.state.reseller,
      inventory: [],
      clients: [],
      selectedProducts: [],
      selectedClient: null,
      saveOrderToCRM: functions.httpsCallable("popshapCRM-createClientsOrder"),
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return (
          option.name.toLowerCase().indexOf(temp) > -1 ||
          option.sku.toLowerCase().includes(temp)
        );
      },
    };
  },
  firestore() {
    return {
      clients: db.collection(`reseller_profile/${this.user.id}/clients`),
    };
  },
  created() {
    this.getAllProducts();
  },
  computed: {
    calcTotalPrice() {
      var total = this.selectedProducts.reduce(function (prev, cur) {
        let retail = cur.original_price;
        if (cur.selected_quantity < 50) {
          let discount = parseFloat(cur.prices["1_49"]);
          return (prev += parseFloat(cur.selected_quantity * discount));
        } else if (cur.selected_quantity >= 50 && cur.selected_quantity < 100) {
          let discount = parseFloat(cur.prices["50_99"]);
          return (prev += parseFloat(cur.selected_quantity * discount));
        } else if (
          cur.selected_quantity >= 100 &&
          cur.selected_quantity < 500
        ) {
          let discount = parseFloat(cur.prices["100_499"]);
          return (prev += parseFloat(cur.selected_quantity * discount));
        } else if (cur.selected_quantity >= 500) {
          let discount = parseFloat(cur.prices["500_"]);
          return (prev += parseFloat(cur.selected_quantity * discount));
        }
      }, 0);

      return total;
    },
    order() {
      let user = this.user;
      let index = user.client_order_index + 1 || 1;
      let order = {
        created_at: Date.now(),
        status: "REQUESTED",
        order_number: `${index}`.padStart(4, "0"),
        total: this.calcTotalPrice,
        client: {
          id: this.selectedClient.id,
          title: this.selectedClient.title,
          companyName: this.selectedClient.company_name,
          phone: this.selectedClient.phone,
          first_name: this.selectedClient.first_name,
          last_name: this.selectedClient.last_name,
          email: this.selectedClient.email,
        },
        shipping_address: this.selectedClient.address,
        billing_address: this.selectedClient.address,
      };
      return order;
    },
    crm_order() {
      let user = this.user;
      let index = user.client_order_index + 1 || 1;
      let order = {
        created_at: Date.now(),
        order_number: `${index}`.padStart(4, "0"),
        status: "PENDING",
        client: {
          id: this.selectedClient.id,
          title: this.selectedClient.title,
          companyName: this.selectedClient.company_name,
          phone: this.selectedClient.phone,
          first_name: this.selectedClient.first_name,
          last_name: this.selectedClient.last_name,
          email: this.selectedClient.email,
        },
        reseller: {
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
          company: user.company,
        },
        shipping_address: this.selectedClient.address,
        billing_address: this.selectedClient.address,
      };
      return order;
    },
  },
  methods: {
    activate(item) {
      if (this.details == item.sku) {
        this.details = null;
      } else {
        this.details = item.sku;
      }
    },
    newClient() {
      let id = db.collection("client").doc().id;
      this.goTo("/order/" + id);
    },
    checkNum(item) {
      if (item.selected_quantity > item.quantity) {
        item.selected_quantity = item.quantity;
        return Swal.fire("Can't select more than whats in stock");
      }

      if (item.selected_quantity < 0) {
        item.selected_quantity *= -1;
      }
    },
    async completeOrder() {
      if (this.selectedClient && this.selectedProducts.length) {
        let loader = this.$loading.show({
          container: null,
          canCancel: false,
        });
        let order_ref = db
          .collection(`reseller_profile/${this.user.id}/orders`)
          .doc();

        await order_ref.set(this.order, { merge: true });
        await this.createLineItems(order_ref.id);
        await this.saveOrderToCRM({
          order: Object.assign(
            {
              id: order_ref.id,
            },
            this.crm_order
          ),
          user: this.user.id,
        }).then(() => {
          loader.hide();
          Swal.fire(
            "You're Order has been submitted for review, the popshap team will contact you on the status of your order"
          ).then(() => {
            this.$router.push("/orders");
          });
        });
      } else {
        Swal.fire(
          "You must select a client and minimum of one product to complete this order"
        );
      }
    },
    async createLineItems(order_id) {
      let batch = db.batch();
      let productPromise = await this.selectedProducts.map(
        async (product, index) => {
          let line_item = {
            name: product.name,
            sku: product.sku,
            quantity: product.selected_quantity,
            unit_price: this.calcDiscountedPrice(product),
            total_price: this.calcTotalPrice,
            item_path: await db
              .collection("reseller_profile")
              .doc(this.user.id)
              .collection("products")
              .doc(product.id),
          };

          let line_item_ref = await db
            .collection(
              `reseller_profile/${this.user.id}/orders/${order_id}/line_items`
            )
            .doc(product.id);

          batch.set(line_item_ref, line_item, { merge: true });

          if (index == this.selectedProducts.length - 1) {
            await batch.commit();
          }
        }
      );

      return Promise.all(productPromise);
    },
    formatPrice(payload) {
      let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return formatter.format(payload);
    },
    calcDiscountedPrice(item) {
      if (item.selected_quantity <= 49) {
        return item.prices["1_49"];
      } else if (item.selected_quantity >= 50 && item.selected_quantity <= 99) {
        return item.prices["50_99"];
      } else if (
        item.selected_quantity >= 100 &&
        item.selected_quantity <= 499
      ) {
        return item.prices["100_499"];
      } else if (item.selected_quantity >= 500) {
        return item.prices["500_"];
      }
    },
    calculateDiscountPercentage(item) {
      let retail = item.original_price;
      if (item.selected_quantity <= 49) {
        return (
          Math.round(((item.prices["1_49"] - retail) / retail) * 100) + "% Off"
        );
      } else if (item.selected_quantity >= 50 && item.selected_quantity <= 99) {
        return (
          Math.round(((item.prices["50_99"] - retail) / retail) * 100) + "% Off"
        );
      } else if (
        item.selected_quantity >= 100 &&
        item.selected_quantity <= 499
      ) {
        return (
          Math.round(((item.prices["100_499"] - retail) / retail) * 100) +
          "% Off"
        );
      } else if (item.selected_quantity >= 500) {
        return (
          Math.round(((item.prices["500_"] - retail) / retail) * 100) + "% Off"
        );
      }
    },
    getAllProducts() {
      db.collection(`reseller_profile/${this.user.id}/products`)
        .where("quantity", ">", 0)
        .get()
        .then((snapshot) => {
          this.inventory = snapshot.docs.map((p) =>
            Object.assign({ id: p.id, selected_quantity: 1 }, p.data())
          );
        });
    },
  },
};
</script>

<style lang="scss">
.totals {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
  p {
    margin-left: 40px;
    font-size: 15px;
    span {
      font-size: 35px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
    }
  }
}
</style>
